/**
 * 连接状态横幅。
 *
 * 为什么这条必须存在：三个人各在各家、不能通话。卡住的时候他们无法互相
 * 询问「是游戏挂了还是我信号断了」—— 界面是唯一能回答这个问题的地方。
 * 没有它，一次地铁进隧道就会变成三个人各自干等、互相猜疑。
 *
 * online 时不显示任何东西：一切正常就不该占屏幕。
 */
export function ConnectionBanner({ state }: { state: 'connecting' | 'online' | 'offline' }) {
  if (state === 'online') return null
  const offline = state === 'offline'
  return (
    <div
      role="status"
      className={[
        'px-3 py-2 text-center text-sm font-semibold',
        offline ? 'bg-red-900 text-red-100' : 'bg-amber-900 text-amber-100',
      ].join(' ')}
    >
      {offline ? '已断开，正在重连…（席位和你的牌都还留着）' : '连接中…'}
    </div>
  )
}
